<template>
  <div class="content">
    <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80">
      <FormItem label="账号" prop="Accountnumber">
        <Input  v-model="formCustom.Accountnumber" prefix="md-person"></Input>
      </FormItem>
      <FormItem label="密码" prop="passwd">
        <Input type="password" v-model="formCustom.passwd" prefix="md-power"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit('formCustom')" long >登录</Button>
        <!-- <Button @click="handleReset('formCustom')" style="margin-left: 8px">Reset</Button> -->
      </FormItem>
      <FormItem>
          <!-- <Button type="text" style="float: right" lin>修改密码</Button> -->
          <router-link :to="{name: 'changepassword'}" style="float: right">修改密码</router-link>
      </FormItem>
    </Form>
  </div>
</template>

<script>
// import axios from '../../../utils/request'
import { login } from '../../../api/login'
import { Menuinfo } from '../../../api/Menu'

export default {
  name: 'content',
  data () {
    const validateAccountnumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入你的账号'))
      } else {
        if (this.formCustom.Accountnumber !== '') {
          // 对第二个密码框单独验证
          this.$refs.formCustom.validateField('Accountnumber')
        }
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入你的密码'))
      } else if (!this.formCustom.check) {
        callback(new Error('密码或账号不正确'))
      } else {
        callback()
      }
    }

    return {
      formCustom: {
        passwd: '',
        Accountnumber: '',
        age: '',
        check: true
      },
      ruleCustom: {
        Accountnumber: [{ validator: validateAccountnumber, trigger: 'blur' }],
        passwd: [{ validator: validatePass, trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleSubmit (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          login({
            User: this.formCustom.Accountnumber,
            Password: this.formCustom.passwd
          }).then((res) => {
            if (res.isSuccess) {
              this.$Message.success('Success!')
              this.$store.commit('setUserInfo', res.data[0])
              this.$store.commit('setToken', res.token)
              this.$store.commit('setIsLogin', true)
              this.GetMenuList(res.data[0].userID)
            } else {
              this.$Message.error(res.message)
            }
          })
        } else {
          this.$Message.error('Fail!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    },
    // 获取菜单信息
    GetMenuList (userid) {
      Menuinfo(userid).then((res) => {
        if (res.IsSuccess) {
          this.$store.commit('setMenuList', res.Data)
          this.$router.push({ name: 'Home_home' })
        } else {
          this.$Message.error(res.message)
        }
      })
    }
  }
}
</script>
<style scoped>
.content{
    margin: 1rem;
}
.Change-Password{
    float:right;
}
</style>
